import React from 'react';
import { useTranslation } from 'next-i18next';
import PropTypes from 'prop-types';

import CheckboxFilter from '@spa/shared/components/Filters/Checkbox';
import Group from '@spa/shared/components/Filters/Group';
import { GENDER_RESTRICTIONS } from '@spa/shared/constants/genderRestrictions';

const { FEMALE_ROOM, FEMALE_PROPERTY, MALE_ROOM, MALE_PROPERTY } = GENDER_RESTRICTIONS;

const GENDER_RESTRICTIONS_CHECKBOXES = [
  { filter: FEMALE_ROOM, text: 'Female-only room', subtext: 'May share common areas with any gender.' },
  { filter: FEMALE_PROPERTY, text: 'All-female property', subtext: 'Entire property is restricted to women only.' },
  { filter: MALE_ROOM, text: 'Male-only room', subtext: 'May share common areas with any gender.' },
  { filter: MALE_PROPERTY, text: 'All-male property', subtext: 'Entire property is restricted to men only.' }
];

const GenderPreferences = ({ fields, onChangeEventHandler }) => {
  const { t } = useTranslation('translations');

  const onGenderFiltersChange = event => onChangeEventHandler(event, true);

  return (
    <Group title={t('Gender preferences')}>
      {GENDER_RESTRICTIONS_CHECKBOXES.map(({ filter, text, subtext }) => (
        <CheckboxFilter
          key={filter}
          name={'restrictions-gender'}
          value={filter}
          onChange={onGenderFiltersChange}
          selected={fields['restrictions-gender'] && fields['restrictions-gender'] === filter}
          label={t(text)}
          helperText={t(subtext)}
        />
      ))}
    </Group>
  );
};

GenderPreferences.propTypes = {
  fields: PropTypes.object.isRequired,
  onChangeEventHandler: PropTypes.func.isRequired
};

export default GenderPreferences;
